export default class ApiStatus {
    constructor(){ }

    static check(){
        if (top.document.domain == document.domain) {
          $('#protector').remove();
        }

        var hash = window.location.hash;
        var doFail = false;
        var route = __DEV__ ? 'api_status': '/be/api_status';
        if(hash != ''){
            doFail = hash.split('?')[1].split('=')[1];
            if(doFail == 'true'){
                route += '?fail=true';
            }
        }

        var host = window.location.origin;
        if(__DEV__){
            host = BE_URL;
        }

        // if there is an api error then show api status error message
        // otherwise ignore
        var introDiv = document.getElementsByClassName("intro-cta")[0];
        $.ajax({
            url:host + route,
            method:"GET"
        }).done( data => {
            introDiv.innerHTML = '<a href="survey.html" class="btn intro-btn"><span>Start</span> your application<svg width="11px" height="7px" viewBox="0 0 11 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Chevron" transform="translate(5.500000, 3.500000) scale(-1, 1) rotate(-90.000000) translate(-5.500000, -3.500000) translate(2.000000, -2.000000)"><path d="M2.73072318,8.24562566 L4.63576159e-06,5.49708378 L2.73072318,2.74854189 C4.23262881,1.23684093 5.46800132,0 5.47599801,0 C5.49495828,0 6.97534238,1.49013256 6.97534238,1.50921633 C6.97534238,1.51721845 6.08875298,2.41611559 5.00514371,3.50676034 L3.03494503,5.48975822 L5.0159798,7.4837211 L6.99700298,9.47769565 L6.24378444,10.2359374 C5.8295096,10.6529576 5.48400629,10.9941676 5.4760096,10.9941676 C5.46800132,10.9941676 4.23262881,9.75732662 2.73072318,8.24562566 Z" id="Fill-1"></path></g></g></svg></a><div class="note" flex><img src="img/icon-warning.svg" alt=""><div>Note: In-process applications cannot be saved. If you exit before completing your application and payment, all information will be lost.</div></div></div>';
        }).error(data => {
            introDiv.innerHTML = '<div class="note" flex><img src="img/icon-warning.svg" alt="">Sorry, the application is currently unavailable. Please try again later.</div>';
        });
    }
}



// WEBPACK FOOTER //
// dev/js/ApiStatus.js